import { FlexBox } from '@fable/components'
import { CompChildren, CompProps } from '@fable/types'
import { useStatsPermission } from '../../lib/hooks'
import { useStats } from '../../lib/ctx/stats'
import { isAndroid } from 'app/webview/utils'
import { css } from '@fable/theme'

interface Props {
  actions?: CompChildren
}

export const StatsHeader = ({ children, actions }: CompProps<Props>) => {
  const isOnboarding = useStats((s) => s.isOnboarding)
  const { isStatsOwner } = useStatsPermission()

  return (
    <FlexBox
      className={css`
        position: relative;
        width: 100%;
      `}
      justifyContent="space-between"
    >
      {children}
      {!!actions && isStatsOwner && !isOnboarding && !isAndroid ? (
        <FlexBox data-testid="stats-header-actions" gap="4px">
          {actions}
        </FlexBox>
      ) : null}
    </FlexBox>
  )
}
